export interface IListView {
  list: Array<any>
  fields: Array<any>
  total: number
  page: number
  limit: number
  filters: object
  views: Array<IListView>
  attrs: any
  settings: any
  sort: { sortBy: string | null; sortDesc: boolean }
}

export interface IObjectView {
  viewId: string | null
  object: any
  attrs: any
  settings: any
  views: Array<IListView>
}

export interface IState {
  listView: IListView
  objectViews: Array<IObjectView>
}

export const commonState: IState = {
  listView: {
    list: [],
    fields: [],
    total: 0,
    page: 1,
    limit: 20,
    filters: {
      filter: {},
      searchStr: '',
      advanced: [],
      quick: [],
    },
    sort: { sortBy: null, sortDesc: false },
    views: [],
    attrs: {},
    settings: {
      title: '',
      viewSettings: null,
      userViewsettings: null,
      objectData: {},
      selectedRows: null,
    },
  },
  objectViews: [],
}
